module.exports = __webpack_public_path__ + "static/media/alert2.e14c6098.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/alert2.mp3
// module id = 1600
// module chunks = 0